import React from 'react';

const MobileHeader = ({ onMenuClick, title }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      background: 'white',
      borderBottom: '1px solid #e5e7eb',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button
          onClick={onMenuClick}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px'
          }}
        >
          ☰
        </button>
        <h1 style={{ fontSize: '18px', fontWeight: '600', margin: 0, color: '#374151' }}>
          {title}
        </h1>
      </div>
    </div>
  );
};

export default MobileHeader;
